import axios from 'axios';

const API_URL = 'https://sportips.fr/file_attente/';
class WaitingQueueService {
    async init() {
        // get relative url
        let relativeUrl = window.location.pathname;
        //encode url
        relativeUrl = encodeURIComponent(relativeUrl);

        try {
            let res = await axios.get(API_URL + 'init2.php?origin=i&from=' + relativeUrl, {
                withCredentials: true,
                timeout: 5000
            });
            if (res.data.in_queue) {
                // redirect to waiting queue
                window.location.href = "https://attente.sportips.fr/file_attente/public/waiting.php";
            }
        } catch (error) {
            console.error(error);
            return null;
        }
    }
}

export default new WaitingQueueService();